import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useInitialValues = () => {
  const metaData = useSelector((state: any) => state.metaData);

  const initialValues = useMemo(
    () => ({
      subject: `Important documents from ${metaData.companyNameShort || ""}`,
      body: `Hello,\n\nPlease see the attached notice regarding your Account.\n\n{company-logo}\nBest regards,\n${
        metaData.companyNameShort || ""
      } Team`,
    }),
    [metaData]
  );

  return { initialValues };
};
